export default "__VITE_PUBLIC_ASSET__7c47791c__"